<template>
  <div :id class="accordion border-y border-y-border">
    <button
      v-blokkli-editable:field_title
      class="group flex w-full items-center justify-between gap-2 py-3 text-left text-size-6 tablet:py-4 tablet:text-size-5 desktop:text-size-4-5"
      @click="open = !open"
    >
      <span
        class="font-bold"
        :class="{
          'group-hover:text-primary-light': !isOpen,
        }"
        >{{ title }}</span
      >
      <IconArrowToggle
        :open="isOpen"
        class="size-[0.8em] shrink-0 transition-transform duration-300 ease-bounce tablet:size-[1em]"
      />
    </button>
    <VuepalTransitionHeight
      :easing-enter="EASE_SWING"
      :easing-leave="EASE_SWING"
      :duration="300"
      opacity
    >
      <div v-show="isOpen" class="pb-3 tablet:pb-4">
        <slot />
      </div>
    </VuepalTransitionHeight>
  </div>
</template>

<script lang="ts" setup>
import { EASE_SWING } from '../../../settings/tailwind'

const props = defineProps<{
  id?: string
  title?: string
  isOpen?: boolean
}>()

const open = ref(false)

const isOpen = computed(() => open.value || props.isOpen)
</script>

<style>
@reference '~/assets/css/tailwind.css';
.accordion + .accordion {
  @apply border-t-0;
}
</style>
